// extracted by mini-css-extract-plugin
export default {"rating":"cz-z","numberOfStars":"dz-z","count":"ez-z","barGraphSpacing":"fz-z","barGraph":"gz-z"};